<template>
  <dx-grid
    url="schedules"
    :columns="columns"
    :title="title"
    :sortOptions="{
      enabled: true,
      field: 'dateCreated',
      type: 'desc',
    }"
    :expandedOptions="{
      enabled: true,
      template: 'schedule-details',
    }"
  ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../utils/helpers.js";

export default {
  data: () => ({
    title: "Schedules",
    columns: [
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          switch (value) {
            case "Completed":
              return "mdi-check-circle";
            case "Scheduled":
              return "mdi-clock";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "Completed":
              return "success";
            case "Scheduled":
              return "#fdb400";
            default:
              return "#aeb8bf";
          }
        },
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Account ID",
        field: "accountID",
        format: "",
        template: "link-cell-template",
        link: (row) => {
          return [
            "DINNER WEB",
            "DINNER IVR",
            "DINNER PORTAL",
            "Dinner App",
            "DINNER ADMIN PORTAL",
          ].includes(row.source)
            ? "DinnerAccountView"
            : "Account View";
        },
        showLink: (row) => {
          return true;
        },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date Created",
        field: "dateCreated",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "End Date",
        field: "endDate",
        type: "date",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Successful Schedule",
        field: "lastSuccessfulSchedule",
        visible: false,

        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        type: "date",
        format: "",
      },
      {
        label: "Next Schedule Date",
        field: "nextScheduleDate",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        type: "date",
      },
      {
        label: "Amount",
        field: "totalAmount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Amount Processed",
        field: "amountProcessed",
        format: {
          type: "currency",
          precision: 2,
        },
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Payment Type",
        field: "paymentType",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "User",
        field: "userName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Total Schedules",
        field: "totalSchedules",
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Processed",
        field: "processed",
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Canceled",
        field: "canceled",
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Scheduled",
        field: "scheduled",
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Declined",
        field: "declined",
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Error",
        field: "error",
        type: "number",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Card Type",
        field: "cardType",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Card Ending",
        field: "cardNumLast5",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Enabled",
        field: "isEnabled",
        type: "boolean",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  methods: {},
};
</script>
<style></style>
